import { lazy } from 'react';

export const LazyBrowseTemplateGalleryPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--browse-template-gallery-page" */ './browse-template-gallery-page'
    ),
);
